export const CarIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 48 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M17.538 19.385h13.847m-24.923 0l-5.539-2.77V9.231m0 0l2.77-4.616-.924-1.846A66.37 66.37 0 0119.385.923M.923 9.231h5.539l-1.847 3.692H.923m18.462-12c10.153 0 18.461 7.385 18.461 7.385M19.385.923l3.692 18.462m14.77-11.077s7.384 0 9.23 4.615v6.462h-4.615M37.846 8.308H9.231L7.385 1.846M24.923 12h2.77m-10.155 5.538a5.538 5.538 0 11-11.076 0 5.538 5.538 0 0111.076 0zm-3.692 0a1.846 1.846 0 11-3.692 0 1.846 1.846 0 013.692 0zm24.923 0a1.846 1.846 0 11-3.692 0 1.846 1.846 0 013.692 0zm3.693 0a5.538 5.538 0 11-11.077 0 5.538 5.538 0 0111.076 0z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
